import React from 'react';
import $ from 'jquery';
import PreloginHome from '../../prelogin/src/PreloginHome';
import { BrowserRouter as Router, Link, Redirect, Route, Switch } from "react-router-dom";
import BrowserUtil from '../../util/BrowserUtil';
import UserStorageUtil from '../../util/UserStorageUtil';
import sidebar_props from '../../model/AppConstants.js';

import ScrollToTopOnMount from '../../prelogin/src/components/ScrollToTopOnMount.js';
import Banner from './za_Banner.js';
import EventDetails from './za_EventDetails';
import RecognisedStatic from './za_RecognisedStatic';
import LessonFeatures from './za_LessonFeatures.js';
import OurTeachers from './za_OurTeachers';
import StaticFeed from './za_StaticFeed';
import SignupSection from './za_SignupSection.js';
import UnifiedForgotPwd from './za_UnifiedForgotPwd';
import Footer from './za_Footer.js';
import UnifiedLogin from './za_UnifiedLogin';
import SignupForm from './za_SignupForm';
import ComponentRegistry from '../../model/ComponentRegistry.js';
import Home from '../../views/plp/Home';
import Dashboard from '../../views/dashboard/Dashboard';
import Scorecard from '../../views/scorecard/Scorecard';

class za_PreloginHome extends PreloginHome {

    constructor(props) {
        super(props);
        this.showHideLeftMenu = this.showHideLeftMenu.bind(this);

        this.getHeaderLogo = this.getHeaderLogo.bind(this);
    }

    componentWillMount() {
        super.componentWillMount();
    }

    componentDidMount() {

        super.componentDidMount();

        this.setFavIco();

        try {
            var isCollapsed = (this.getAttribute("sidebar_collapsed") === "true");

            //UserStorageUtil.getStoredSessionItem("sidebar_collapsed") ||
            sidebar_props.collapsed = isCollapsed || sidebar_props.collapsed;

            if (sidebar_props.collapsed === true) {
                $('.side-navbar').addClass('shrinked');
                $('.content-inner').addClass('active');
                $('#toggle-btn').removeClass('active');
                $('#toggle-btn').removeClass("goRight");
                $('.navbar-header .brand-small').show();
                $('.navbar-header .brand-big').hide();
            }
        } catch (e) {
            console.error(e);
        }

        if ($(window).outerWidth() > 1183) {
            if ($('#toggle-btn').hasClass('active')) {
                $('#toggle-btn').addClass("goRight");
            } else {
                $('#toggle-btn').removeClass("goRight");
            }
        }
        if ($(window).outerWidth() < 1183) {
            $('#toggle-btn').removeClass("goRight");
        }

        this.appendCSS("./vendors/za_main.css");
    }

    /**
    * IMPORTANT: Please follow this way to use favIcon
    */
    setFavIco() {
        if (window.fav_ico_by_prefix && window.fav_ico_by_prefix[this.getUser().getSchoolPrefix()]) {
            if (document.getElementsByName("fav_ico").length > 0) {
                document.getElementsByName("fav_ico")[0].href = window.fav_ico_by_prefix[this.getUser().getSchoolPrefix()];
            }
        }
    }

    toggleSideBar() {
        $('#toggle-btn').toggleClass('active');

        $('.side-navbar').toggleClass('shrinked');
        $('.content-inner').toggleClass('active');
        if ($(window).outerWidth() > 1183) {
            if ($('#toggle-btn').hasClass('active')) {
                $('.navbar-header .brand-small').hide();
                $('.navbar-header .brand-big').show();
                $('#toggle-btn').addClass("goRight");
            } else {
                $('.navbar-header .brand-small').show();
                $('.navbar-header .brand-big').hide();
                $('#toggle-btn').removeClass("goRight");
            }
        }

        if ($(window).outerWidth() < 1183) {
            $('.navbar-header .brand-small').show();
            $('#toggle-btn').removeClass("goRight");
        }

        try {
            var isCollapsed = $('.side-navbar').hasClass('shrinked');


            if (typeof isCollapsed === "boolean") {
                this.setAttribute("sidebar_collapsed", isCollapsed.toString());
            }


            sidebar_props.collapsed = $('.side-navbar').hasClass('shrinked');
            UserStorageUtil.storeSessionItem("sidebar_collapsed", sidebar_props.collapsed);
        } catch (e) {
            console.log(e);
        }

        try {
            var isCollapsed = (this.getAttribute("sidebar_collapsed") === "true");
            console.log("isCollapsed::::", isCollapsed);
            //UserStorageUtil.getStoredSessionItem("sidebar_collapsed") ||
            sidebar_props.collapsed = isCollapsed || sidebar_props.collapsed;

            if (sidebar_props.collapsed === true) {
                $(".page-content .content-inner").toggleClass("fullwidth");
                $(".page-content nav.side-navbar").toggle();
                $(".page-content nav.side-navbar").toggleClass('collapsed');
            }
        } catch (e) {
            console.error(e);
        }
    }


    getButtonName() {
        //console.log("lumos login::::",this.state.LumosloggedIn);
        if (this.state.loggedIn || this.state.LumosloggedIn || (BrowserUtil.getAuthToken() && BrowserUtil.getAuthToken().length >= 5) || (BrowserUtil.getLumosToken() && BrowserUtil.getLumosToken().length >= 5)) {
            //return this.rb("menu.home");
            return this.rb("btn.label.myheymath");
        }
        return this.rb("btn.label.signin");
    }

    getFaceBookEvent = () => {
        if (window.facebookEventAvailForZA) {
            return (
                <EventDetails></EventDetails>
            )
        }
    }

    Home = () => {
        if (!this.tracked) {
            this.getAdsTracker().callByReferer({ "eventType": "trackCustom", "eventName": "home-PageView" });
            this.tracked = true;
        }

        try {
            if (this.state.LumosloggedIn) {
                window.location.href = this.getUrlFor("LUMOS_REDIRECT_URL");
            } else if (this.state.PLPloggedIn && !window.location.href.match("/home")) {
                window.location.href = "/landing";
            }
        } catch (e) { }

        this.selectedMenu = "menuhome";
        var me = this;
        return (
            <div>
                {me.setTitle("HOME_title")}
                {me.setMeta("HOME_meta")}
                {me.setHeading("HOME_heading")}
                <div id="bannerElement">{this.getBannerContent()}</div>
                <ScrollToTopOnMount />
                <Banner products_category_order={this.getProductsTypeOrder()} products_category={this.getProductsType()} classes={this.getClasses()} grades={this.getGrades()} products_class={this.getProductsClass()} PLPloggedIn={this.state.PLPloggedIn} startFreeTrial={this.startFreeTrial} showSignUp={this.showSignUp} showNewLoginForm={this.showNewLoginForm}></Banner>
                {/* {this.getFaceBookEvent()} */}
                <LessonFeatures></LessonFeatures>
                <RecognisedStatic></RecognisedStatic>
                <OurTeachers></OurTeachers>
                <StaticFeed></StaticFeed>
                <SignupSection PLPloggedIn={this.state.PLPloggedIn} startFreeTrial={this.startFreeTrial} showSignUp={this.showSignUp} showNewLoginForm={this.showNewLoginForm}></SignupSection>
                <Footer showContactus={this.showContactus} products_category_order={this.getProductsTypeOrder()} products_category={this.getProductsType()} classes={this.getClasses()} grades={this.getGrades()} products_class={this.getProductsClass()}></Footer>
                {this.fireMobileToast()}
            </div>
        );
    }
    /*
    * IMPORTANT: Hardcoded temporarily. Needs to be addressed post demo
    */
    getHeaderLogo() {
        if (this.getUser().getSchoolPrefix() && this.getUser().getSchoolPrefix().length > 0) {
            if (this.getUser().getSchoolPrefix().toLowerCase() === "ms_") {
                return (
                    <img src="/img/mindstretcher/logo.png" alt="Mind Stretcher logo" />
                )
            } else {
                return super.getHeaderLogo();
            }
        } else {
            return super.getHeaderLogo();
        }
    }



    renderLoginView = () => {

        if (this.state.loggedIn == true) {
            //console.warn("this.UserStore ",this.UserStore);
            return (
                <div className="inlineblock">

                    <div className="inlineblock navbar-nav">
                        <li className="nav-item dropdown">
                            <div className="nav-link dropdown-toggle" href="#" id="navbardrop" data-toggle="dropdown">

                                {this.state.imageLoaded ? <img className="material-icons md-60  usericon imgprv" src={this.state.imagePreviewUrl} /> : <i className="material-icons md-40 useraccountelement">account_circle</i>}
                            </div>
                            <div className="dropdown-menu">
                                {/* <div className="dropdown-item pflename">{this.UserStore.getUserName() || this.UserStore.getLoginId()}</div> */}
                                <a className="dropdown-item" href="/settings" ><i className="material-icons pr-16">account_circle</i> My Profile</a>
                                <a className="dropdown-item" href="#" onClick={() => { this.onLogout() }}><i className="material-icons pr-16">power_settings_new</i> Sign out</a>
                            </div>
                        </li>
                    </div>
                </div>
            );
        }
    }

    getUnifiedLoginForm(loginType = null, userid = null, errMsg = null) {
        return (
            <div>
                <div className="row">
                    <div className="col-12 nopadding">
                        <UnifiedLogin myProps={this.props} loginType={loginType} userid={userid} callbackForgotPwd={this.showForgotPasswordForm} callbackCreateAccount={this.showCreateAccount} showSignUp={this.showSignUp} navigateURL={'/products'} errMsg={errMsg} />
                    </div>
                    <br />
                </div>
            </div>
        );
    }

    getVerifyAccount(loginType = null, userInput = null, navigateurl = null, freetrail = null) {
        if (navigateurl == null) {
            navigateurl = '/products';
        }
        return (
            <SignupForm signupUser={'student'} myProps={this.props} loginType={loginType} data-ga={this.modalcloseDataGA} userInput={userInput} successRegisterMsg={this.showsuccessRegisterMsg} navigateURL={navigateurl} freetrail={freetrail} gaFrom={this.gaFrom} />
        );
    }

    getForgotPassword(source) {
        return (
            <div>
                <div className="row">
                    <div className="col-12 nopadding">
                        <UnifiedForgotPwd myProps={this.props} pwdIframeView={this.pwdIframeView} source={source} successForgotPwd={this.showSuccessForgotPwdMessage} showNewLoginForm={this.showNewLoginForm} />
                    </div>
                </div>
            </div>
        );
    }

    getSingleLoginForm(event) {

        let loginSource = event.currentTarget.dataset.source || '';

        if (loginSource == "" || loginSource == "lumos" || loginSource == "plp") {
            this.modalcloseDataGA = "Home - Users who have independently registered - Close";
            this.setState({ "ModalShow": true, "ModalContent": this.getUnifiedLoginForm(), "ModalHeader": "logo", customClass: "newloginDialog" });
        } else if (loginSource == "register") {
            this.modalcloseDataGA = "Home - Sign in - Users who want to register - Close";
            this.setState({ "ModalShow": true, "ModalContent": this.getVerifyAccount(), "ModalHeader": this.rb("login.createnewaccount"), customClass: "newloginDialog" });
        }
    }

    getSwitcher() {
        return (
            <Switch>
                <Route exact path='/' component={this.Home} maintainScrollPosition={true} />
                <Route exact path='/home' component={this.Home} maintainScrollPosition={true} />
                <Route path="/landing" exact component={Home} />
                <Route path="/dashboard" exact component={Dashboard} />
                <Route path="/settings" exact component={this.GetMyProfile} />
                <Route path="/scorecard/:id/:reset?" exact component={Scorecard} />
                {/* 
    <Route path="/report" exact component={Report} />
    <Redirect from="/classes" to="/products"/>
    <Route path='/products' component={this.Products}  maintainScrollPosition={true}/>
    <Route path='/our-learnings' component={this.Learnings} maintainScrollPosition={true}/>
    <Route path='/who-we-are' component={this.WhoWeAre} maintainScrollPosition={true}/>
    <Route path='/blog' component={this.Blog} maintainScrollPosition={true}/>
    <Route path='/spotlight' component={this.Spotlight} maintainScrollPosition={true}/>
    <Route path="/faq" component={this.Faq} maintainScrollPosition={true} />
    <Route path='/self-learning/:id' component={this.SelfPaced} maintainScrollPosition={true}/>
    <Route path='/personalised-learning/:id' component={this.Plp} maintainScrollPosition={true}/>
    <Route path='/cbse-exam/:id' component={this.cbse} maintainScrollPosition={true}/>
    <Route exact path='/product-details' component={this.GetProductDetails} maintainScrollPosition={true}/>
    <Route exact path='/teachers' component={this.Teachers} maintainScrollPosition={true}/>
    <Route exact path='/sg' component={this.SGCatalogue} maintainScrollPosition={true}/>  
    <Redirect from="/myproducts" to="/mysubscriptions"/>
    <Route path="/mysubscriptions" exact component={this.GetMyProducts} maintainScrollPosition={true}/> */}
                <Redirect from='*' to='/' />
                {/*<Route exact path="/404" component={this.Home} />
    <Route component={this.Home} />*/}

            </Switch>
        )
    }

    getRouter() {
        var me = this;
        return (
            <Router>
                <div>
                    <header className="clearfix">

                        <nav className="nav-desktop">
                            <div className="container-fluid norightpadding">
                                {/* <div className="showhidemenu">
            <a id="toggle-btn" href="#" className="menu-btn active" onClick={this.showHideLeftMenu}>
                <i className="material-icons">menu</i>
            </a>
        </div> */}
                                <div className="logo"><Link to="/home" onClick={me.setPreloginClass}>{this.getHeaderLogo()}</Link></div>


                                <ul className="textAlignLeft"><span></span></ul>
                                {/* {(() => {
                                    if (!this.state.loggedIn) {
                                        return (<div className="za_announcement"><span><img src="./images/icons/heart_za.png" alt='education' /> {me.rb("za_header.title1")} <img src="./images/icons/hand_za.png" alt='education' />{me.rb("za_header.title2")}</span></div>);
                                    }
                                })()} */}


                                <div className="r-sec">

                                    <a data-ga="My HeyMath Tab" className={"r-btn myheymathbtn mr-30 " + me.getMargin()} onClick={me.showLoginForm}>{me.getButtonName()}</a>
                                    {me.renderLoginView()}

                                </div>
                            </div>
                        </nav>

                    </header>
                    <div className="clearfix"></div>
                    {me.getSwitcher()}

                </div>
            </Router>
        )
    }
    showHideLeftMenu() {
        //$(".page-content nav.side-navbar").toggle();
        $(".page-content .content-inner").toggleClass("fullwidth");
        $(".page-content nav.side-navbar").toggle();
        $(".page-content nav.side-navbar").toggleClass('collapsed');

        try {
            var isCollapsed = $('nav.side-navbar').hasClass('collapsed');


            if (typeof isCollapsed === "boolean") {
                this.setAttribute("sidebar_collapsed", isCollapsed.toString());
            }


            sidebar_props.collapsed = $('nav.side-navbar').hasClass('collapsed');
            UserStorageUtil.storeSessionItem("sidebar_collapsed", sidebar_props.collapsed);
        } catch (e) {
            //console.log(e);
        }


    }

    render() {
        /*require('./ms_main.css');*/

        return super.render(
            this.getRouter()
        );
    }
}

export default za_PreloginHome;

ComponentRegistry.register("za_PreloginHome", za_PreloginHome);

/*
* Also registering for the users with hm_ prefix
*/
ComponentRegistry.register("Preloginhome", za_PreloginHome);


// WEBPACK FOOTER //
// ./src/views/za/za_PreloginHome.js